import { render } from "./SubstituteHolidayChange.vue?vue&type=template&id=1faac6ba"
import script from "./SubstituteHolidayChange.vue?vue&type=script&lang=js"
export * from "./SubstituteHolidayChange.vue?vue&type=script&lang=js"

import exportComponent from "/home/timecard-test/OggiTimeClockSystem/electron/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__